// extracted by mini-css-extract-plugin
export default {"datePickerStyles":"pure-date-picker_datePickerStyles__-wc+b"};